<template>
	<templateLogin>
		<div class="header">
		</div>
		<div class="body">
			<section class="box-login">
				<section class="box-content">
					<div class="title">
						<h1>Solicitar alteração de senha</h1>
						<p>Como deseja receber o código para alteração?</p>
					</div>
					<div v-show="message.text"
						v-html="message.text"
						:class="{
							'message': message.type === 'error',
							'message-success': message.type === 'success',
							'mb-15': true
						}" />
					<section class="options">
						<ul>
							<li>
								<label class="fac-check-card">
									<input type="radio" name="tipo-msg" value="email" v-model="form.type" />
									<span class="label">Por e-mail</span>
								</label>
							</li>
							<li>
								<label class="fac-check-card">
									<input type="radio" name="tipo-msg" value="mobile" v-model="form.type" />
									<span class="label">Por SMS</span>
								</label>
							</li>
						</ul>
					</section>
					<div class="control">
						<ui-button :disabled="!form.type"
							:loading="status === 'loading'"
							type="submit"
							design="lg primary block"
							@click="send">
							Solicitar
						</ui-button>
					</div>
					<div class="back-link">
						<router-link to="/login"><i class="fal fa-long-arrow-left"></i> Voltar</router-link>
					</div>
				</section>
			</section>
		</div>
	</templateLogin>
</template>
<script>
	import templateLogin from '@/templates/page-login'
	import { uiButton } from '@/components/ui/buttons'

	import { resetPassword } from '../../services/axios'

	export default {
		components: { templateLogin, uiButton },

		data() {
			return {
				form: {
					email: '',
					type: ''
				},
				message: {
					text: '',
					type: 'success'
				},
				status: false
			}
		},

		created() {
			this.form.email = this.$route.params.email
			this.form.type = this.$route.params.type
		},

		mounted() {
			this.checkMobile()
		},

		methods: {
			/**
			 * Envia um código de autenticação via e-mail ou SMS para o usuário
			 */
			send() {
				this.status = 'loading'
				resetPassword.recover(this.form).then(response => {
					if ("error" !== response.data.status) {
						let routeName = 'passwordRecoverValidateTokenEmail'
						if (this.form.type !== 'email') routeName = 'passwordRecoverValidateTokenSMS'

						this.$router.push({
							name: routeName,
							params: {
								user_id: response.data.data.user_id,
								email: this.form.email
							}
						})
					}
					this.message = {
						text: response.data.msg,
						type: response.data.status
					}
					this.status = false
				})
			},
			/**
			 * Verifica se o usuário possui um celular cadastrado para permitir envio de SMS
			 */
			checkMobile() {
				if (this.form.type) this.send()
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import '~@/assets/styl/base.styl'
	.options
		ul
			list-style none
			padding 0
			margin 0
			padding-bottom 20px
			li
				margin-bottom -1px


	.fac-check-card:hover
		border 1px grey-light-0 solid

	.fac-check-card
		align-items center
		font-size 12px
		cursor pointer
		border 1px grey-light-1 solid
		padding 15px 20px
		display flex
		width 100%
		text-align left
		radius(5px)
		transitionTime(0.2s)
		background #FFF
		margin-bottom 0
		position relative
		z-index 5

		input
			appearance none
			-webkit-appearance none
			-moz-appearance none
			width 28px
			height 28px
			radius(50%)
			position relative
			cursor pointer
			display flex
			align-items center
			justify-content center
			border 1px grey-light-0 solid
			transitionDefault()
			color facilita-4
			margin-right 10px
			background #f9f9fc
			outline: none
	
		input:after
			content "\f00c"
			position absolute
			line-height 0
			font-size 12px
			font-family "Font Awesome 5 Pro"
			opacity 0.3
			display flex
			align-items center
			-moz-osx-font-smoothing: grayscale;
			-webkit-font-smoothing: antialiased;

		input:checked:after
			opacity 1
			font-size 12px
			opacity 1

		input:checked
			background success-3
			color #FFF
			border 1px success-3 solid
			+ span
				font-weight 600


</style>
